/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

import * as React from "react";

import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

interface AppWaitNoticeProps {
    readonly notice: string
}

export default function AppWaitNotice({notice}: AppWaitNoticeProps) {
    return (
        <Container>
            <Typography
                sx={{
                    textAlign: "center",
                    padding: 1
                }}>
                {notice}
            </Typography>
        </Container>
    );
}
